import React, { useMemo, useState, useRef } from "react";
import { Field, useFormikContext } from "formik";
import { makeStyles } from "@material-ui/core/styles";
import {
  FormControl,
  InputAdornment,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/SearchOutlined";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
  selectInputField: {
    "& .MuiSvgIcon-root": { color: theme.palette.text.primary, },
	},
}));

const BanksSelect = ({ banks }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();
  const timeoutBankRef = useRef(null);

  const { setFieldValue, touched, errors } = useFormikContext();

  const [searchTextBank, setSearchTextBank] = useState("");



  //  ***************
  //  ** Functions **
  //  ***************
  const handleSelectBank = (event) => {
    setFieldValue("bankId", event.target.value);
  };

  const handleResetSearchText = () => {
    if (timeoutBankRef.current) clearTimeout(timeoutBankRef.current);
    timeoutBankRef.current = setTimeout(() => setSearchTextBank(""), 250);
  };

  const handleSearchText = (event) => {
    setSearchTextBank(event.target.value.toLowerCase());
  };

  const containsText = (text="", searchText) => {
    return text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
  };

  const avoidEventPropagation = (event) => {
    if (event.key !== "Escape") event.stopPropagation();
  };



  //  ***********
  //  ** Memos **
  //  ***********
  const displayedBankOptions = useMemo(
    () => banks.filter(bank => containsText(`${bank.code} - ${bank.name}`, searchTextBank)),
    [banks, searchTextBank]
  );



  //  ************
  //  ** Return **
  //  ************
  return (
    <FormControl
      classes={{ root: classes.selectInputField }}
      variant="outlined"
      margin="dense"
      error={touched.bankId && Boolean(errors.bankId)}
      helperText={touched.bankId && errors.bankId}
      fullWidth
    >
      <InputLabel>{i18n.t("banksSelect.bank")}</InputLabel>
      <Field
        as={Select}
        name="bankId"
        label={i18n.t("banksSelect.bank")}
        onChange={(event) => handleSelectBank(event)}
        onClose={handleResetSearchText}
        MenuProps={{
          autoFocus: false,
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          getContentAnchorEl: null,
        }}
      >
        <ListSubheader disableSticky>
          <TextField
            autoFocus
            fullWidth
            size="small"  
            placeholder={i18n.t("banksSelect.searchTextPlaceholder")}
            style={{ marginTop: "1em" }}
            value={searchTextBank}
            onChange={(event) => handleSearchText(event)}
            onClick={(event) => avoidEventPropagation(event)}
            onKeyDown={(event) => avoidEventPropagation(event)}
            inputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon /></InputAdornment>) }}
          />
        </ListSubheader>

        {displayedBankOptions.map(bank => (
          <MenuItem value={bank.id}>{bank.code} - {bank.name}</MenuItem>
        ))}
      </Field>
    </FormControl>
  );
};

export default BanksSelect;
